import { JsonObject, JsonProperty } from 'json2typescript';

import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { ProfessionalPositionInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('ProfessionalPosition')
export class ProfessionalPosition implements ProfessionalPositionInterface {
    @JsonProperty('Id', IdAdapter, true)
    private _id: Id = undefined;

    @JsonProperty('Code', StringAdapter, true)
    private _code: string = undefined;

    @JsonProperty('Name', StringAdapter, true)
    private _name: string = undefined;

    @JsonProperty('Risk', Boolean, true)
    private _risk = false;

    get id(): Id {
        return this._id;
    }

    get code(): string {
        return this._code;
    }

    get name(): string {
        return this._name;
    }

    get risk(): boolean {
        return this._risk;
    }

    toString(): string {
        return this.code + ' - ' + this.name;
    }
}
